<div class=" justify-content-center text-center  mt-4 row">

    <h4 class="col-12 text-primary ">
      An email containing a password link has been sent to you!!
    </h4>
       <div class="d-flex flex-column align-items-center">
          
          <button type="button" class="btn btn-primary col-8 col-md-2 mt-4" routerLink="/">Goto Homepage</button>
        </div>
</div>
